import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=54970954&scoped=true"
import script from "./Withdraw.vue?vue&type=script&lang=js"
export * from "./Withdraw.vue?vue&type=script&lang=js"
import style0 from "./Withdraw.vue?vue&type=style&index=0&id=54970954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54970954",
  null
  
)

export default component.exports